<template>
  <div class="main">
    <my-header :title="device.name || ''"></my-header>
    <div class="container">
      <div v-if="isCCT">
        <div @click="change(0)">
          <span class="radius" mode1 :selected="selected === 0"></span>
          <span>冷白</span>
        </div>
        <div @click="change(1)">
          <span class="radius" mode2 :selected="selected === 1"></span>
          <span>晨曦</span>
        </div>
        <div @click="change(2)">
          <span class="radius" mode3 :selected="selected === 2"></span>
          <span>月光</span>
        </div>
      </div>
      <div :class="{ 'special-do': !isCCT }">
        <div @click="change(3)" v-if="isCCT">
          <span class="radius" mode4 :selected="selected === 3"></span>
          <span>暖黄</span>
        </div>
        <div @click="change(4)" v-if="isCCT">
          <span class="radius" mode5 :selected="selected === 4"></span>
          <span>夕阳</span>
        </div>
        <div @click="showCustom">
          <img src="@/assets/images/device/light/d-zdy.png" style="width: 90px" />
          <span>自定义</span>
        </div>
      </div>
      <div>
        <div @click="powerSwitch">
          <img :src="icon" style="width: 80px" />
          <span>开关</span>
        </div>
      </div>
    </div>
    <modal name="setting" :width="370" :height="250" @opened="setting = true" @closed="setting = false">
      <div class="modal">
        <div class="title">
          <span v-text="`${device.name}-自定义设置`"></span>
          <img src="@/assets/images/home/cha.png" style="width: 18px" @click="$modal.hide('setting')" />
        </div>
        <div class="br" v-if="isBR">
          <div class="sub-title"><span>亮度调节：</span></div>
          <div class="just-center">
            <range-slider class="slider" min="0" max="100" step="1" v-model="br" @change="changeBR"></range-slider>
            <span class="val" v-text="`${br}%`"></span>
          </div>
        </div>
        <div class="cct" v-if="isCCT">
          <div class="sub-title"><span>色温调节：</span></div>
          <div class="just-center">
            <range-slider class="slider" min="2700" max="6500" step="100" v-model="cct" @change="changeCCT"></range-slider>
            <span class="val" v-text="`${cct}K`"></span>
          </div>
          <div class="desc">
            <div>
              <span class="title">暖色</span>
              <br />
              <span class="sub-title">2700K</span>
            </div>
            <div>
              <span class="title">冷色</span>
              <br />
              <span class="sub-title">6500K</span>
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import RangeSlider from "vue-range-slider";
import Modal from "vue-js-modal";
import "vue-range-slider/dist/vue-range-slider.css";
import MyHeader from "@/components/HeaderTitle";
import { Message } from "element-ui";
import { mapState } from "vuex";
import api from "@/model/device";

Vue.use(Modal);
export default {
  name: "Light",
  data() {
    return {
      selected: -1,
      setting: false,
      cct: 2700,
      br: 80,
      systemSetting: [
        {
          name: "冷白",
          br: 90,
          cct: 6000,
        },
        {
          name: "晨曦",
          br: 75,
          cct: 6500,
        },
        {
          name: "月光",
          br: 50,
          cct: 5500,
        },
        {
          name: "暖黄",
          br: 90,
          cct: 3800,
        },
        {
          name: "夕阳",
          br: 40,
          cct: 2700,
        },
      ],
      isCCT: this.device.enableCCT === 1,
      isBR: this.device.enableBR === 1,
      isGroup: false,
      copyDevice: {},
    };
  },
  props: {
    device: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    ...mapState(["lights"]),
    icon() {
      if (this.copyDevice["state"]) {
        return require("@/assets/images/device/kt-kgk.png");
      } else {
        return require("@/assets/images/device/kt-kg.png");
      }
    },
  },
  watch: {
    lights: {
      handler(data) {
        if (this.device.include) {
          let state = data.filter((itm) => this.device.include.includes(itm.id)).some((item) => item.state);
          this.$set(this.device, "state", state);
        }
      },
      deep: true,
    },
    device: {
      handler(data) {
        this.copyDevice = data;
      },
      deep: true,
    },
  },
  components: {
    MyHeader,
    RangeSlider,
  },
  created() {
    if (!this.device.name) {
      // 没有传递需要的参数，返回上级页面
      this.$router.replace({ name: "light" });
    }
    this.isGroup = this.$route.params.group;
  },
  mounted() {
    if (this.device) {
      this.cct = this.device.cct;
      this.br = this.device.brightness;
      this.copyDevice = this.device;
    }
  },
  methods: {
    async change(i) {
      this.selected = i;
      // 找到i对应的设置
      const setting = this.systemSetting[i];
      try {
        if (this.isGroup) {
          await api.batchControl("light", "br", setting.br, this.device["include"]);
          await api.batchControl("light", "cct", setting.cct, this.device["include"]);
        } else {
          await api.singleControl(this.device, "br", setting.br);
          await api.singleControl(this.device, "cct", setting.cct);
        }
      } catch (e) {
        Message.error(e.message);
      }
    },
    showCustom() {
      this.$modal.show("setting", { adaptive: true, pivotX: 0.1, pivotY: 0.1 });
    },
    async changeBR() {
      try {
        if (this.isGroup) {
          await api.batchControl("light", "br", this.br, this.device["include"]);
        } else {
          await api.singleControl(this.device, "br", this.br);
        }
      } catch (e) {
        Message.error(e.message);
      }
    },
    async changeCCT() {
      try {
        if (this.isGroup) {
          await api.batchControl("light", "cct", this.cct, this.device["include"]);
        } else {
          await api.singleControl(this.device, "cct", this.cct);
        }
      } catch (e) {
        Message.error(e.message);
      }
    },
    async powerSwitch() {
      try {
        if (this.isGroup) {
          await api.batchControl("light", this.device.state ? "close" : "open", "", this.device["include"]);
        } else {
          await api.singleControl(this.device, this.device.state ? "close" : "open");
        }
      } catch (e) {
        Message.error(e.message);
      }
    },
  },
};
</script>
<style scoped lang="less">
@import "../../assets/less/base";

.main {
  & .modal {
    padding-left: 20px;
    padding-top: 20px;
    padding-right: 20px;
    & .title {
      font-size: 17px;
      font-weight: 600;
      color: rgba(38, 38, 38, 1);
      margin-bottom: 20px;
    }
    & img {
      float: right;
      cursor: pointer;
    }
    & .sub-title {
      margin-top: 15px;
      margin-bottom: 5px;
      font-size: 15px;
      font-weight: 400;
      color: rgba(38, 38, 38, 1);
    }
    & .range {
      width: 262px;
      margin-right: 10px;
    }
    & .just-center {
      display: flex;
      align-items: center;
      > .val {
        font-size: 15px;
        font-weight: 400;
        margin-left: 4px;
        width: 50px;
        color: rgba(38, 38, 38, 1);
      }
      > .slider {
        flex: 1;
        width: 0;
      }
    }
    & .desc {
      margin-top: 8px;
      padding-left: 5px;
      width: 268px;
      display: flex;
      justify-content: space-between;
      & .title {
        font-size: 12px;
        font-weight: 400;
        color: rgba(85, 85, 85, 1);
      }
      & .sub-title {
        font-size: 9px;
        font-weight: 300;
        color: rgba(128, 128, 128, 1);
      }
    }
  }
  & .container {
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
    flex: 1;
    padding-bottom: 20px;
    > div {
      min-height: 120px;
      width: 500px;
      display: flex;
      justify-content: space-between;
      > div {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 16px;
        font-weight: 600;
        color: rgba(89, 89, 89, 1);
        img {
          margin-bottom: 10px;
          cursor: pointer;
        }
      }
    }
    .radius {
      display: inline-block;
      min-width: 90px;
      min-height: 90px;
      cursor: pointer;
      border-radius: 50%;
      margin-bottom: 10px;
    }

    .radius[selected] {
      min-width: 84px;
      min-height: 84px;
      border: 3px solid #e5e5e5;
    }

    .radius[mode1] {
      background: linear-gradient(180deg, rgba(235, 237, 238, 1), rgba(253, 251, 251, 1));
    }
    .radius[mode2] {
      background: linear-gradient(180deg, rgba(172, 224, 249, 1), rgba(234, 244, 248, 1));
    }
    .radius[mode3] {
      background: linear-gradient(180deg, rgba(195, 207, 226, 1), rgba(245, 247, 250, 1));
    }
    .radius[mode4] {
      background: linear-gradient(180deg, rgba(252, 238, 159, 1), rgba(246, 211, 101, 1));
    }
    .radius[mode5] {
      background: linear-gradient(180deg, rgba(237, 110, 160, 1), rgba(254, 210, 105, 1));
    }

    > div:first-child {
      margin-top: 100px;
    }
    > div:nth-child(2) {
      margin-top: 60px;
    }
    > div:last-child {
      min-height: 100px;
      margin-top: 70px;
      align-items: center;
      justify-content: center;
      img {
        margin-bottom: 0px;
      }
      > div {
        font-size: 13px;
        font-weight: 400;
      }
    }
  }
}
</style>
<style lang="less">
.br {
  & .slider {
    width: 260px;
    .range-slider-fill {
      background: linear-gradient(90deg, rgba(90, 208, 98, 1), rgba(119, 216, 87, 1));
    }
    & .range-slider-rail,
    .range-slider-fill {
      height: 10px;
      border-radius: 6px;
      box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.12);
    }
    & .range-slider-knob {
      height: 26px;
      width: 26px;
      background: rgba(76, 203, 107, 1);
      box-shadow: 0px 1px 8px 1px rgba(76, 203, 107, 0.4);
      border: 0;
    }
  }
}

.cct {
  & .slider {
    width: 260px;
    & .range-slider-rail {
      background: linear-gradient(90deg, rgba(244, 110, 1, 1), rgba(252, 220, 135, 1), rgba(255, 255, 255, 1), rgba(226, 234, 253, 1));
    }
    .range-slider-fill {
      background: transparent;
    }
    & .range-slider-rail,
    .range-slider-fill {
      height: 10px;
      border-radius: 6px;
      box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.12);
    }
    & .range-slider-knob {
      height: 26px;
      width: 26px;
      /*background: rgba(76, 203, 107, 1);*/
      box-shadow: 0px 1px 8px 1px rgba(155, 155, 155, 0.4);
      border: 0;
    }
  }
}

.v--modal-overlay[data-modal="setting"] {
  /*background: transparent;*/
  height: 100% !important;
  .v--modal-background-click {
    height: 100%;
  }
}

.v--modal {
  top: 35% !important;
  left: 50% !important;
  transform: translate(-50%, -50%);
  border-radius: 6px;
}
.special-do {
  justify-content: center !important;
}
</style>
